import { requireService, wrap } from '@repo/di-ez';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import styles from './trajectory-empty-state.module.scss';

export const TrajectoryEmptyState = wrap(function TrajectoryEmptyState() {
  const { t } = useTranslation();
  const trajectoryService = requireService('trajectoryService');

  if (!trajectoryService.hasWell) {
    return <div className={clsx('dash-body-regular', styles.emptyState)}>{t('Empty.noWell')}</div>;
  }

  if (!trajectoryService.hasWellboreSelection) {
    return <div className={clsx('dash-body-regular', styles.emptyState)}>{t('Empty.noWellbore')}</div>;
  }

  if (!trajectoryService.hasTrajectorySelection) {
    return <div className={clsx('dash-body-regular', styles.emptyState)}>{t('Empty.noTrajectory')}</div>;
  }

  return null;
});
